import { ADMIN_API_PREFIX } from '@/services/admin-api';
// @ts-ignore
/* eslint-disable */
import { request } from 'umi';

/** Get captcha ID GET /api/admin/v1/captcha/id */
export async function getCaptchaId(options?: { [key: string]: any }) {
  return request<API.ResponseResult<API.Captcha>>(`${ADMIN_API_PREFIX}/captcha/id`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** Response captcha image GET /api/admin/v1/captcha/image */
export function getCaptchaImageURL(id: string) {
  return `${ADMIN_API_PREFIX}/captcha/image?captcha_id=${id}&reload=1&ts=${new Date().getTime()}`;
}

/** Login system with username and password POST /api/admin/v1/login */
export async function login(body: API.LoginForm, options?: { [key: string]: any }) {
  return request<API.ResponseResult<API.LoginToken>>(`${ADMIN_API_PREFIX}/login`, {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** Logout system POST /api/admin/v1/current/logout */
export async function logout(options?: { [key: string]: any }) {
  return request<API.ResponseResult<any>>(`${ADMIN_API_PREFIX}/current/logout`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** Query current user menus based on the current user role GET /api/admin/v1/current/menus */
export async function fetchCurrentMenus(options?: { [key: string]: any }) {
  return request<API.ResponseResult<API.Menu[]>>(`${ADMIN_API_PREFIX}/current/menus`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** Change current user password PUT /api/admin/v1/current/password */
export async function updateCurrentPassword(
  body: API.UpdateLoginPassword,
  options?: { [key: string]: any },
) {
  return request<API.ResponseResult<any>>(`${ADMIN_API_PREFIX}/current/password`, {
    method: 'PUT',
    data: body,
    ...(options || {}),
  });
}

/** Refresh current access token POST /api/admin/v1/current/refresh-token */
export async function refreshToken(options?: { [key: string]: any }) {
  return request<API.ResponseResult<API.LoginToken>>(`${ADMIN_API_PREFIX}/current/refresh-token`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** Get current user info GET /api/admin/v1/current/user */
export async function getCurrentUser(options?: { [key: string]: any }) {
  return request<API.ResponseResult<API.User>>(`${ADMIN_API_PREFIX}/current/user`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** Change current user info PUT /api/admin/v1/current/user */
export async function updateCurrentUser(body: API.User, options?: { [key: string]: any }) {
  return request<API.ResponseResult<any>>(`${ADMIN_API_PREFIX}/current/user`, {
    method: 'PUT',
    data: body,
    ...(options || {}),
  });
}
